<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col my-auto text-center">
          <h1 class="title">Full-Service Sales Experience</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 text-center">
          <img v-bind:src="conciergeService" style="width: 400px; height: 250px;">
          <h3>Concierge Service</h3>
          <p>Don't bother with the headache of selling your home! HomApt Realty and Marketplace partners create a hassle-free experience.</p>
        </div>
        <div class="col-md-4 text-center">
          <img v-bind:src="signage" style="width: 400px; height: 250px;">
          <h3>Signage</h3>
          <p>Ready to list your house? HomApt provides yard and directional signs to increase foot traffic to your home.</p>
        </div>
        <div class="col-md-4 text-center">
          <img v-bind:src="photos" style="width: 400px; height: 250px;">
          <h3>Photos and 3D Scan</h3>
          <p>Professional real estate photos and 3D scan will be taken of your home to increase potential buyer viewings.</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-4 offset-md-2 text-center">
          <img v-bind:src="drone" style="width: 400px; height: 250px;">
          <h3>Drone Services</h3>
          <p>Want to give potential buyers an understanding of your neighborhood? Allow our Drone Services to create an impactful experience to potential buyers.</p>
        </div>
        <div class="col-md-4 text-center">
          <img v-bind:src="onlineMls" style="width: 400px; height: 250px;">
          <h3>Online MLS Listing</h3>
          <p>HomApt will publish your listing to the HomApt website as well as MLS to ensure full exposure of your home on websites like Zillow, Truilia and Realtor.com.</p>
        </div>
      </div>
    </div>
    <div class="container contact-section">
      <div class="row">
        <div class="col-md-6">
          <img class="realtor-photo" src="../../../static/KatiePhoto.jpg">
        </div>
        <div class="col-md-6">
          <h2 class="sub-header">Contact our team of agents today!</h2>
          <p class="realtor-text">Do you work odd hours and want help finding a home now? HomApt Professionals are here to support you when you need it. Get access to home showings that are convenient with your schedule. Days, nights, weekends? HomApt is ready to assist.
            We can work with you on pricing, review your purchase agreement, review your seller’s disclosures and much more.</P>
      <div class="row">
        <div class="col my-auto">
          <a href="tel:1-612-655-2324"><button class="btn btn-primary btn-bottom">Call</button></a>
        </div>
        <div class="col my-auto">
          <a href="mailto:realty@homapt.com"><button class="btn btn-primary btn-bottom">E-Mail</button></a>
        </div>
      </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Professional Support',
    meta: [
      { vmid: 'description', content: 'fill in' }
    ]
  },
  computed: {
    imagePrefix () {
      return 'https://s3.' +
              window.CONFIG.Region + '.amazonaws.com/' +
              window.CONFIG.PhotoBucketName +
              '/xsmall/uploads/'
    },
    conciergeService () {
      return this.imagePrefix + 'AndyDeanPhotog_Int0415_7482-Keys.jpg'
    },
    signage () {
      return this.imagePrefix + 'AndyDeanPhotog_SHse_4614-SOLD_Lft_2.jpg'
    },
    photos () {
      return this.imagePrefix + 'AndyDeanPhotog_1215_4372_DRAW.jpg'
    },
    drone () {
      return this.imagePrefix + 'AndyDeanPhotography_Drone_0005.jpg'
    },
    onlineMls () {
      return this.imagePrefix + 'K-S48-Ake-4201.jpg'
    }
  }
}
</script>

<style scoped>
.contact-section {
  background-color: var(--dark-color);
  padding-bottom: 6rem;
  padding-top: 6rem;
}

.needs-padding {
  padding-top: 1rem;
}

.btn-bottom {
  margin-top: 2rem;
}

.agents {
  background-color: #feedaa;
}
.container {
  margin-bottom: 3rem;
}

.agent-pic {
  margin-top: 1rem;
  border-radius: 50%;
}

img {
  object-fit: cover;
}

.popover__title {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 24px;
  line-height: 36px;
  text-decoration: none;
  color: rgb(228, 68, 68);
  text-align: center;
  padding: 15px 0;
}

.popover__wrapper {
    position: relative;
    margin-top: 1.5rem;
    display: inline-block;
}
.popover__content {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    left: 50%;
    margin-left: -150px !important;
    transform: translate(0,10px);
    background-color: white;
    padding: 1.5rem;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
    width: 300px;
}
.popover__content:before {
    position: absolute;
    z-index: -1;
    content: '';
    right: calc(50%);
    top: -8px;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent white transparent;
    transition-duration: 0.3s;
    transition-property: transform;
}
.popover__wrapper:hover .popover__content {
    z-index: 10;
    opacity: 1;
    visibility: visible;
    transform: translate(0,-20px);
    transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
}
.popover__message {
  text-align: left;
}

.realtor-photo {
  border-radius: 50%;
  display: block;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
  width: 300px;
}

.realtor-text {
  color: var(--secondary-background-color) !important;
}

.sub-header {
  color: var(--secondary-background-color) !important;
  margin-bottom: 2rem;
}

.title {
  margin-bottom: 6rem;
  margin-top: 6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profsupport/TheProfSupport.vue